// /assets/datalayer-helper.js (runtime copy of /tracking/datalayer-helper.js)
(function () {
  window.dataLayer = window.dataLayer || [];

  function getCookie(name) {
    try {
      return document.cookie
        .split('; ')
        .find(r => r.startsWith(name + '='))?.split('=')[1] || '';
    } catch { return ''; }
  }

  function getGAClientId() {
    try {
      const parts = getCookie('_ga').split('.');
      return parts.length >= 4 ? parts[2] + '.' + parts[3] : '';
    } catch { return ''; }
  }

  function ensureUUID() {
    try {
      let uuid = localStorage.getItem('amorosa_uuid') || '';
      if (!uuid) {
        // RFC4122 v4
        uuid = (crypto && crypto.randomUUID) ? crypto.randomUUID() : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
        localStorage.setItem('amorosa_uuid', uuid);
      }
      return uuid;
    } catch { return ''; }
  }

  const identity = {
    uuid: ensureUUID(),
    ga_client_id: getGAClientId(),
    fbp: getCookie('_fbp'),
    fbc: getCookie('_fbc'),
    ttclid: new URLSearchParams(location.search).get('ttclid') || '',
    gclid: new URLSearchParams(location.search).get('gclid') || '',
    wbraid: new URLSearchParams(location.search).get('wbraid') || '',
    gbraid: new URLSearchParams(location.search).get('gbraid') || '',
    fbclid: new URLSearchParams(location.search).get('fbclid') || ''
  };

  // Safe, non-throwing push
  window.AMOROSA_DL = function pushEvent(payload) {
    try {
      const merged = Object.assign(
        { event_time: Date.now(), identity },
        payload
      );
      window.dataLayer.push(merged);
    } catch (e) { /* no-op */ }
  };
})();


